import RoleService from '../../Services/roleService';
import EvaluatorPaymentStatusEnum from '../../Enums/EvaluatorPaymentStatusEnum';
import EvaluatorPaymentViewsEnum from '../../Enums/EvaluatorPaymentViewsEnum';

// CD-5483: whether the signed-in user's roles let Approve act on evaluator payments of both stacks. The approver roles
// approve only Assignment Payments pending supervisor approval (the server then checks each against their approval
// scope); every other manual Approve needs the 'evaluatorpayment_approveotherpayments' rule, the server's
// EvaluatorPaymentApprovalScope.CanApproveOtherPayments. The grids' status gates still decide on top of this.
export default class EvaluatorPaymentApproveHelper {
  static IsOpenToUser(statusCode: number, type: string): boolean {
    return (
      (statusCode === EvaluatorPaymentStatusEnum.PendingApprovalBySupervisor && type === 'Assignment Payment') ||
      RoleService.CheckUserPermission('special_case', 'evaluatorpayment_approveotherpayments')
    );
  }

  // The bulk Approve: every selected row must be open to the user. A selection of the whole search set also holds rows
  // the page has not loaded, which only the Pending Supervisor Approval view guarantees to be open to an approver.
  static IsSelectionOpenToUser(
    everySelectedRowIsOpen: boolean,
    allItemsInTheSearchSetAreSelected: boolean,
    view: string
  ): boolean {
    return (
      everySelectedRowIsOpen &&
      (!allItemsInTheSearchSetAreSelected ||
        view === EvaluatorPaymentViewsEnum.PendingSupervisorApproval ||
        RoleService.CheckUserPermission('special_case', 'evaluatorpayment_approveotherpayments'))
    );
  }
}
